import React, { Select } from "formik-antd";
/**
 * Maps a given time zone option to a Select.Option element.
 *
 * @param {Object} option - The time zone option object.
 * @param {string} [option.name] - The name of the time zone.
 * @param {number} [option.id] - The identifier of the time zone.
 * @returns {JSX.Element} The rendered Select.Option element.
 */
export function mapTimeZones(option: { name?: string; id?: number }) {
  return (
    <Select.Option value={option.name} key={option.id}>
      {option.name}
    </Select.Option>
  );
}
